import React from "react";

export default function Ex1_Data() {
  return (
    <div>
      <h1>Ex1_Data</h1>
      <p>This is the Ex1_Data component.</p>
    </div>
  );
}
